<template>
  <custom-btn-icon
    small
    :isText="isText"
    :href="href"
    target="_blank"
    btn-text="P2O"
    icon="mdi-progress-clock"
    @click="onClick"
    :color="color"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';
import { setDispActive } from '@/services/api/internal/requestActions/selfAssign.api';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';

export default {
  name: 'LinkToP2O',
  components: { CustomBtnIcon },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAssigned: {
      type: Boolean,
      required: false,
      default: false,
    },
    isText: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      isDispatcher: `${AUTHORIZATION_MODULE_PATH}/isDispatcher`,
    }),
    href() {
      return `${process.env.P2O_LINK_URL}${
        process.env.P2O_LINK_URL.endsWith('=') ? this.requestId : ''
      }`;
    },
  },
  methods: {
    setDispActive,
    onClick() {
      if (this.isDispatcher) {
        this.setDispActive({
          requestId: this.requestId,
          groupId: this.groupId,
          isPaused: this.isPaused,
          isAssigned: this.isAssigned,
        }).catch((err) => {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('FREE', err)
          );
        });
      }
    },
  },
};
</script>

<style scoped></style>
